<template>
  <div class="mTreeComplex">
    <a-select
      :value="defaultSectionId"
      style="width: 100%;margin-top:10px"
      show-search
      :filter-option="filterEngineeringOption"
      @change="changeSection"
    >
      <a-select-option
        v-for="item in engineerList"
        :key="item.id"
        :value="item.id"
      >
        {{ item.engineeringName }}
      </a-select-option>
    </a-select>

    <div class="iconOp">
      <a-icon type="plus" @click="showModal" />
      <a-modal ref="addForm" v-model="visible" title="添加/编辑组织" on-ok="handleOk">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">
          取消
        </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOk">
          提交
        </a-button>
      </template>
      <template>
        <a-form :label-col="labelCol">
          <a-form-item label="上级组织：">
            <a-input v-model="supZz" allow-clear/>
          </a-form-item>
          <a-form-item label="组织类型：">
            <!-- <a-input v-model="zzType" allow-clear/> -->
<!--             <span v-if="orgPname>3">{{orgName}}</span>-->
            <a-select  v-model="provinceInfo" @change="handleProvinceChange">
              <a-select-option v-for="province in provinceData" :key="province">
                {{ province }}
              </a-select-option>
            </a-select>
            <!-- <a-select
              mode="multiple"
              style="width: 100%"
              @change="handleChange"
              :default-value="zzType"
            >
              <a-select-option v-for="item in orgList" :key="item" :value="item">
              {{item}}
              </a-select-option>
            </a-select> -->
          </a-form-item>
          <a-form-item label="组织名称：">
            <a-select v-model="zzName">
                <a-select-option v-for="city in cities" :key="city">
                  {{ city }}
                </a-select-option>
              </a-select>
            <!-- <a-select
              mode="multiple"
              style="width: 100%"
              @change="handleChange"
            >
              <a-select-option v-for="item in orgList" :key="item.id" :value="item.id">
              {{item.name}}
              </a-select-option>
            </a-select> -->
          </a-form-item>
          <a-form-item label="备注：">
            <a-input v-model="zzbz" allow-clear/>
          </a-form-item>
        </a-form>
      </template>
    </a-modal>
      <a-icon type="edit" @click="editItem" />
      <!-- <a-icon type="caret-up" />
     <a-icon type="caret-down" /> -->
      <a-icon type="delete" @click="deleteItem" />
    </div>
    <div class="btnCon">
      <span @click="openNode">
        <a-icon type="plus-square" />
      </span>
      <span @click="closeNode">
        <a-icon type="minus-square" />
      </span>
    </div>
    <a-input-search
      style="margin-bottom: 8px"
      placeholder="请输入节点名称"
      @change="onChange"
    />
    <a-tree
      style="margin: 0 10px;"
      :expanded-keys.sync="expandedKeys"
      :tree-data="gData"
      :auto-expand-parent="autoExpandParent"
      @expand="onExpand"
      @select="getNode"
      @dragenter="onDragEnter"
      @dragstart="onDragstart"
      @drop="onDrop"
      show-line
      show-icon
      draggable
    >
      <a-icon slot="switcherIcon" type="down" style="padding: 2px;" />
      <!-- <template slot="title" slot-scope="{ title }">
        <span v-if="title.indexOf(searchValue) > -1">
          {{ title.substr(0, title.indexOf(searchValue)) }}
          <span style="color: #f50">{{ searchValue }}</span>
          {{ title.substr(title.indexOf(searchValue) + searchValue.length) }}
        </span>
        <span v-else>{{ title }}</span>
      </template> -->

      <template slot="title" slot-scope="item">
        <span v-if="item.isEdit">
          <a-input
            ref="new"
            type="text"
            class="editInput"
            v-model.trim="newItem"
            @pressEnter="addConfirm(item)"
          />
          <a-icon type="close-circle" @click="addCancel(item)" />
          <a-icon type="check-circle" @click="addConfirm(item)" />
        </span>
        <div v-else>
          <!-- <span class="node-title">{{ item.title }}</span> -->
          <span v-if="item.name.indexOf(searchValue) > -1">
            {{ item.name.substr(0, item.name.indexOf(searchValue)) }}
            <span style="color: #f50">{{ searchValue }}</span>
            {{
              item.name.substr(
                item.name.indexOf(searchValue) + searchValue.length
              )
            }}
          </span>
          <!-- v-else -->
          <span v-else>{{ item.name }}</span>
          <!-- <span class="icon-wrap">
              <a-icon type="plus" title="添加子集" @click="addItem(item)" />
            </span> -->
          <!-- <span class="icon-wrap">
              <a-icon type="edit" title="编辑"  @click="editItem(item)" />
            </span> -->
          <!-- <span class="icon-wrap">
              <a-icon type="delete" title="删除"  @click="deleteItem(item)" />
            </span> -->
        </div>
      </template>
    </a-tree>
  </div>
</template>
<script>
import { mapState } from "vuex";
import {
  getCurrentTime,
  getCurrentDay,
  getListLikePid ,
  getOrgDataApi,
  addOrganizationApi,
  getEngineerListApi,
  updateOrganizationApi,
  delOrganizationApi,
  getDocumentFileMove
  } from "@/api/api";

const x = 3;
const y = 2;
const z = 1;
const gData = [];

// const generateData = (_level, _preKey, _tns) => {
//   const preKey = _preKey || "0";
//   const tns = _tns || gData;

//   const children = [];
//   for (let i = 0; i < x; i++) {
//     const key = `${preKey}-${i}`;
//     tns.push({
//       title: key,
//       key,
//       scopedSlots: { title: "custom" },
//       isEdit: false,
//       isNewItem: false
//     });
//     if (i < y) {
//       children.push(key);
//     }
//   }
//   if (_level < 0) {
//     return tns;
//   }
//   const level = _level - 1;
//   children.forEach((key, index) => {
//     tns[index].children = [];
//     return generateData(level, key, tns[index].children);
//   });
// };
// generateData(z);

const dataList = [];
const generateList = data => {
  for (let i = 0; i < data.length; i++) {
    const node = data[i];
    const key = node.key;
    dataList.push({ id: node.id, name: node.name });
    if (node.children) {
      generateList(node.children);
    }
  }
};
// generateList(gData);
const addKey = data => {
  data.forEach(f => {
    f.key = f.id
    if (f.children) {
      addKey(f.children)
    }
  })
}
const getParentKey = (key, tree) => {
  console.log(key, tree);
  let parentKey;
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i];
    if (node.children) {
      if (node.children.some(item => item.id === key)) {
        parentKey = node.id;
        console.log(parentKey);
      } else if (getParentKey(key, node.children)) {
        parentKey = getParentKey(key, node.children);
      }
    }
  }
  return parentKey;
};
let mol = []
const getParentPath = (key, tree) => {
  // console.log(key, tree);
  let parentKey;
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i];
    if (node.children) {
      if (node.children.some(item => item.id === key)) {
        parentKey = node.path;
        console.log(node);
        mol = []
        node.children.forEach(item=> {
           mol.push(item.id)
        })
        console.log(mol)
      } else if (getParentPath(key, node.children)) {
        parentKey = getParentPath(key, node.children);
      }
    }
  }
  return parentKey;
};
const provinceData = ['建设单位类型', '其他单位类型'];
const province2Data = ['部门', '标段'];
export default {
  data() {
    return {
      expandedKeys: [],
      searchValue: "",
      autoExpandParent: true,
      gData,
      datas: [], // 暂存的自己及父级的id 层级数组 例如：[爷爷级Id, 父级Id, 自己Id]
      editFlag: false, // 记录是否有已经处于编辑状态的标识
      newFlag: false, // 记录是否是新建节点，用于在cancel的时候判断是该删除还是恢复原样
      newItem: "",
      selectNodes: "",
      sectionListData: [],
      defaultSectionId: "",
      loading: false,
      visible: false,
      loadingUpdate: false,
      visibleUpdate: false,
      supZz: '',
      zzType: '',
      provinceData,
      provinceInfo:provinceData[0],
      cities:[],
      zzName:'',
      zzbz:'',
      zzPid:'',
      zzPpid:'',
      zzPath:'',
      zzPName:'',
      engineerList:[],
      saveFatherId:'',
      moveIdList:[],
      orgName:'',
      orgPname:''
    };
  },
  props: ["type"],
  created() {},
  mounted() {
    this.getEngineerList();
    this.documentFileLikePath();
    this.getOrgData();
  },
  methods: {
    filterEngineeringOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleProvinceChange(){
      this.getOrgData();
    },
    showModal() {

      this.zzbz = '';
      this.zzName = '';
      this.visible = true;
      this.engineerList.forEach(element => {
        if(element.id == this.defaultSectionId){
          this.zzPName = element.engineeringName;
          console.log(this.zzPName)
        }
      });
      if(this.supZz == null || this.supZz == ''){
        this.supZz = this.zzPName;
      }
      let pid = this.getOrgData();
      console.log(pid);
      let le = pid.split("/").length;
      console.log(pid.split("/"))
      console.log(le)
      console.log(this.provinceData)
      if(le > 3){
        this.provinceData = province2Data;
        this.provinceInfo = province2Data[0];
      }else {
        this.provinceData = provinceData;
        this.provinceInfo = provinceData[0];
      }
    },
    handleOk(e) {

      if(this.zzPid == null || this.zzPid == ''){
        this.zzPid = '-'+this.defaultSectionId;
        this.zzPath = '-'+this.defaultSectionId+'/';
      }
      let params = {
        pid:this.zzPid,
        name:this.zzName,
        path:this.zzPath,
        leaf:1,
        type:this.orgPname>3?this.orgName:this.provinceInfo,
        sort:0,
        remark:this.zzbz,
        createDate:getCurrentTime(),
        createBy:1,
        delFlag:0,
        engId:'-'+this.defaultSectionId,
      };
      addOrganizationApi(params).then(res => {
        console.log(res)
        if (res.data.code == 200) {
          this.documentFileLikePath();
        }
      });
      this.loading = true;
      setTimeout(() => {
        this.visible = false;
        this.loading = false;
      }, 3000);
    },
    handleCancel(e) {

      this.visible = false;
      this.supZz = '';
      this.zzPid = '';
      this.zzPath = '';
    },

    // 查询所有工程
    getEngineerList() {
      //
      getEngineerListApi().then(res => {
        if (res.data.code == 200) {
          this.engineerList = res.data.data;
          console.log(this.engineerList);
          this.defaultSectionId = this.engineerList[0].id
        }
      });
    },
    // 根据父类节点查询所有文件
    documentFileLikePath() {
      this.$emit('engVal',this.defaultSectionId)
      let params = {
        path:'-'+this.defaultSectionId,
        //path: 227
      };
      getListLikePid(params).then(res => {
        if (res.data.code == 200) {
          addKey(res.data.data)
          this.gData = res.data.data;
          generateList(res.data.data);
        }
      });
    },

    // 227工程id
    getOrgData() {
      let pid = this.zzPath;
      if(this.zzPpid == this.defaultSectionId){
        pid = this.zzPpid;
      }
      if(pid == '' || pid == undefined){
        pid = "-" + this.defaultSectionId;
      }
      console.log(this.provinceInfo)
      let params = {
        //pid: "-" + this.defaultSectionId,
        pid: pid,
        engineeringId: "-" + this.defaultSectionId,
        //engineeringId: 227,
        type:this.provinceInfo,
        orgName:this.supZz
      };
      getOrgDataApi(params).then(res => {
        if(res.data.code == 200){
          console.log(res.data.data);
          this.cities = res.data.data;
        }
        console.log(res);
      });
      return pid;
    },

    // 选择标段
    changeSection(value) {
      this.defaultSectionId = value;
      window.sessionStorage.setItem("sectionId", this.defaultSectionId);
      this.documentFileLikePath();
    },

    openNode() {
      console.log(dataList);
      let NodeArr = [];
      dataList.forEach(item => {
        NodeArr.push(item.id);
      });
      this.expandedKeys = NodeArr;
      console.log(NodeArr);
    },
    closeNode() {
      this.expandedKeys = [];
    },
    // 增加一级节点
    addFirstItem() {
      if (this.editFlag) {
        this.$message.warning("已有编辑项，请先编辑完成！");
        return;
      }
      this.gData.push({
        children: [],
        id: this.getItemNextId(),
        name: "",
        level: 1,
        scopedSlots: { title: "title" },
        isEdit: true
      });
      this.newItem = "";
      this.editFlag = true;
      this.newFlag = true;
      this.$nextTick(() => {
        this.$refs.new.focus();
      });
    },
    // 自定义修改 item 替换成this.selectNodes.node.dataRef
    addItem(item) {
      console.log(this.selectNodes.node.dataRef);
      if (this.editFlag) {
        this.$message.warning("已有编辑项，请先编辑完成！");
        return;
      }
      // if (this.selectNodes.node.dataRef.children) {
      //   this.$message.warning('文件夹已上传图纸无法新增子级！')
      //   return
      // }
      if (!this.selectNodes.node.dataRef.children) {
        this.selectNodes.node.dataRef.children = [];
      }
      this.selectNodes.node.dataRef.children.push({
        children: [],
        id: this.getItemNextId(),
        name: "",
        // level: item.level + 1,
        scopedSlots: { title: "title" },
        isEdit: true
      });
      this.newItem = "";
      this.editFlag = true;
      this.newFlag = true;
      this.expandedKeys.push(this.selectNodes.node.dataRef.id);
      this.$nextTick(() => {
        this.$refs.new.focus();
      });
    },
    editItem(item) {
      console.log(item);
      console.log(this.selectNodes.node.dataRef);
      //  根目录不允许操作
      if (this.selectNodes.node.dataRef.id == "0-0") {
        return this.$message.warning("根目录名称不支持修改");
      }
      if (this.editFlag) {
        this.$message.warning("已有编辑项，请先编辑完成！");
        return;
      }
      this.selectNodes.node.dataRef.isEdit = true;
      this.newFlag = false;
      this.editFlag = true;
      // this.newItem = item.title
      this.newItem = this.selectNodes.node.dataRef.name;
      this.treeListItemActions(
        this.gData,
        this.selectNodes.node.dataRef.id,
        "edit",
        this.selectNodes.node.dataRef
      );
      this.$nextTick(() => {
        this.$refs.new.focus();
      });
    },
    // 自定义修改 item 替换成this.selectNodes.node.dataRef
    deleteItem(item) {

      console.log(this.selectNodes)
      if (this.selectNodes.node.dataRef.key == "0-0") {
        return this.$message.error("根目录名称不支持删除");
      }
      // if(this.selectNodes.node.dataRef.children) {
      if (
        this.selectNodes.node.dataRef.children &&
        this.selectNodes.node.dataRef.children.length > 0
      ) {
        let that = this;
        that.$message.warning("已有子节点，无法删除！");
        // this.$confirm({
        //   title: '操作提示',
        //   content: '将会删除此节点的所有子节点，确定删除?',
        //   centered: true,
        //   onOk () {
        //     that.treeListItemActions(that.gData, that.selectNodes.node.dataRef.key, 'delete')
        //   },
        //   onCancel () {
        //     that.$message.info('已取消')
        //   }
        // })
      } else {
        let params = {
          id:this.selectNodes.selectedNodes[0].data.props.id
        };
        delOrganizationApi(params).then(res => {
          if (res.data.code == 200) {
            if(res.data.data == 0){
              let that = this;
              that.$message.warning("已添加人员，无法删除！");
            }else{
              this.treeListItemActions(
              this.gData,
              this.selectNodes.node.dataRef.id,
              "delete"
            );
            }
            console.log(res.data)
          }
        });
      }
      // }else {
      //   this.treeListItemActions(this.gData, this.selectNodes.node.dataRef.key, 'delete')
      // }
    },
    addCancel(item) {
      this.newItem = "";
      item.dataRef.isEdit = false;
      this.editFlag = false;
      console.log()
      this.treeListItemActions(
        this.gData,
        item.id,
        this.newFlag ? "delete" : "edit",
        item
      );
    },
    addConfirm(item) {
      //
      console.log(item)
      if (this.newItem !== null && this.newItem.trim() !== "") {
        item.dataRef.name = this.newItem;
        item.dataRef.isEdit = false;
        console.log(item)
        this.editFlag = false;
        this.treeListItemActions(this.gData, item.id, "edit", item);
        let params = {
          id:item.dataRef.id,
          name:item.dataRef.name
        };
        updateOrganizationApi(params).then(res => {
          if (res.data.code == 200) {
            console.log(res.data)
          }
        });
      } else {
        this.$message.warning("不允许为空");
      }
    },
    // 获取新节点的id（时间戳加随机数）
    getItemNextId() {
      return (
        new Date().getTime() + Math.ceil(Math.random() * 10000)
      ).toString();
    },
    // 根据id属性从数组（树结构）中匹配元素，执行action操作
    treeListItemActions(treeList, key, action, item) {
      if (!treeList || !treeList.length) {
        return;
      }
      for (let i = 0; i < treeList.length; i++) {
        console.log(treeList[i].id)
        console.log(key)
        if (treeList[i].id == key) {
          if (action === "delete") {
            treeList.splice(i, 1);
            this.$forceUpdate();
          } else if (action === "edit") {
            // treeList[i] = item;
            this.$forceUpdate();
          }
          break;
        }
        this.treeListItemActions(treeList[i].children, key, action, item);
      }
    },
    // 提供给调用方获取树的数据源的方法
    getData() {
      return this.gData;
    },

    // 递归 获得自己的层级id数组
    getItemAndParentsIdArr(arr, key) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].key === key) {
          this.datas.push(arr[i]);
          return true;
        } else {
          if (
            arr[i].children &&
            this.getItemAndParentsIdArr(arr[i].children, key)
          ) {
            this.datas.push(arr[i]);
            return true;
          }
        }
      }
    },
    // 获得自己的父级id
    getFirstParentId(strings, key) {
      let stringsArr = strings.split("/");
      let index = stringsArr.indexOf(key.toString());
      let parenId;
      if (index !== 0) {
        parenId = stringsArr[index - 1];
      } else {
        parenId = stringsArr[index];
      }
      return parenId;
    },
    getFirstParentIdnew(strings, key) {
      let stringsArr = strings.split("/");
      let index = stringsArr.indexOf(key.toString());
      let parenId;
      // console.log(stringsArr);
      if (index !== 0) {
        parenId = stringsArr[index];
      } else {
        parenId = stringsArr[index];
      }
      // console.log(parenId);
      return parenId;
    },
    // 拖拽
    onDragstart(info) {
      // console.log(info)
       this.getItemAndParentsIdArr(this.gData, info.node.eventKey);
      let dragKeyString = this.datas
        .reverse()
        .map((v, i) => {
          return v.key;
        })
        .join("/");
      const dropKey = info.node.eventKey; // 目标节点的id
      // console.log("父节点", this.getFirstParentId(dragKeyString, dropKey));
      this.saveFatherId = this.getFirstParentId(dragKeyString, dropKey)
    },
    onDragEnter(info) {
      // console.log(info.node.eventKey);
      // expandedKeys 需要受控时设置
      // this.expandedKeys = info.expandedKeys
    },
    onDrop(info) {
      // console.log("拖动完成:", info);
      // console.log(info.node.dataRef.path);
      // console.log(info.dragNode.dataRef.path);
      // 判断是否为同级，不为同级禁止拖拽
      if (
        info.node.dataRef.path.split("/").length !=
        info.dragNode.dataRef.path.split("/").length
      ) {
        return this.$message.warning("仅支持同级目录移动");
      }
      // if (info.dropToGap != true) {
      //   return this.$message.warning("仅支持同级目录移动");
      // }
      this.getItemAndParentsIdArr(this.gData, info.node.eventKey);
      let dragKeyString = this.datas
        .reverse()
        .map((v, i) => {
          return v.key;
        })
        .join("/");
      const dropKey = info.node.eventKey; // 目标节点的id
      const dragKey = info.dragNode.eventKey; // 拖拽节点的id
      // console.log("自身节点", dragKey);
      // console.log("父节点", this.getFirstParentId(dragKeyString, dropKey));
      // console.log('暂存的id ' + this.saveFatherId)
      // console.log('当前id '+this.getFirstParentId(dragKeyString, dropKey))
        if(this.saveFatherId != this.getFirstParentId(dragKeyString, dropKey)) {
          return this.$message.warning("仅支持同级目录移动");
        }
      const dropPos = info.node.pos.split("-");
      const dropPosition =
        info.dropPosition - Number(dropPos[dropPos.length - 1]);
      const loop = (data, key, callback) => {
        data.forEach((item, index, arr) => {
          if (item.key === key) {
            return callback(item, index, arr);
          }
          if (item.children) {
            return loop(item.children, key, callback);
          }
        });
      };
      const data = [...this.gData];
      // Find dragObject
      let dragObj;
      loop(data, dragKey, (item, index, arr) => {
        arr.splice(index, 1);
        dragObj = item;
      });
      // 如果拖动到内部
      if (!info.dropToGap) {
        // Drop on the content
        loop(data, dropKey, item => {
          item.children = item.children || [];
          // where to insert 示例添加到尾部，可以是随意位置
          item.children.push(dragObj);
        });
      } else if (
        (info.node.children || []).length > 0 && // Has children
        info.node.expanded && // Is expanded
        dropPosition === 1 // On the bottom gap
      ) {
        loop(data, dropKey, item => {
          item.children = item.children || [];
          // where to insert 示例添加到尾部，可以是随意位置
          item.children.unshift(dragObj);
        });
      } else {
        let ar;
        let i;
        loop(data, dropKey, (item, index, arr) => {
          ar = arr;
          i = index;
        });
        if (dropPosition === -1) {
          ar.splice(i, 0, dragObj);
        } else {
          ar.splice(i + 1, 0, dragObj);
        }
      }
       this.moveNewNode(
        dragKey,
        this.getFirstParentIdnew(dragKeyString, dropKey)
      );
      this.gData = data;
      // console.log(this.gData);
    },
     async moveNewNode(sVal, fVal) {
      getParentPath(sVal, this.gData)
      let params = {
        // path: getParentPath(sVal, this.gData),
        // pid: fVal,
        // sectionId: this.defaultSectionId,
        // id: sVal,
        ids:mol.join(',')
      };
      console.log(params);
      getDocumentFileMove(params).then(res => {
        if (res.data.code == 200) {
          console.log(res);
          // this.documentFileLikePath();
        }
      });
    },
    // tree change
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    onChange(e) {
      const value = e.target.value;
      console.log(dataList);
      console.log(this.gData);
      const expandedKeys = dataList
        .map(item => {
          if (item.name.indexOf(value) > -1) {
            return getParentKey(item.id, this.gData);
          }
          return null;
        })
        .filter((item, i, self) => item && self.indexOf(item) === i);
      Object.assign(this, {
        expandedKeys,
        searchValue: value,
        autoExpandParent: true
      });
    },
    getNode(selectedKeys, selectedNodes) {
      this.orgPname = selectedNodes.node.dataRef.path.split('/').length
      console.log(this.orgPname)
        this.orgName =selectedNodes.node.dataRef.type =="建设单位类型"?"部门":"标段"
      console.log(selectedKeys);
    this.$emit('childVal',selectedNodes.node.dataRef)
      console.log(selectedNodes.node.dataRef);
      this.zzPid = selectedNodes.node.dataRef.id;
      this.zzPpid = selectedNodes.node.dataRef.pid;
      this.zzPath = selectedNodes.node.dataRef.path
      this.supZz = selectedNodes.node.dataRef.name;
      this.zzType = selectedNodes.node.dataRef.type;
      let node = selectedNodes.node.dataRef;
      this.$emit("getNodes", node);
      this.selectNodes = selectedNodes;
      // 通过selectedNodes.node 触发父节点点击展开子项
      selectedNodes.node.onExpand();
    },
    handleChange(value) {
      console.log(`selected ${value}`);
    }
  },
  // 引入store属性
  computed: {
    ...mapState(["engineerId"])
  },
  watch: {
    engineerId(newVal, oldVal) {
      console.log(newVal, oldVal);
      if (newVal) {
        window.sessionStorage.setItem("EngineerId", newVal);
        this.sectionList();
      }
    },
    // 去掉表单验证信息二次打开残留
    visible(val, newVal) {    //监听的是控制模态框显示或影藏开关的布尔值
        // 监视dialog状态（打开、关闭）
        if (val) {
            try {
                this.$refs['addForm'].resetFields() // 重置编辑表单
                // addForm 为ref指向的表单
            } catch (e) {}
        }else{
          this.supZz = '';
          this.zzPid = '';
          this.zzPath = '';
        }
    }
  }
};
</script>
<style lang="less" scoped>
.mTreeComplex {
  height: 100%;
  .btnCon {
    float: right;
    height: 30px;
    line-height: 44px;
    font-size: 20px;
    color: #989898;
    cursor: pointer;
  }
  .editInput {
    width: 70%;
  }
  .anticon-close-circle,
  .anticon-check-circle {
    background-color: #fff !important;
    color: #177efd !important;
    border-radius: 10px;
    font-size: 16px;
  }
  padding: 0 10px;
  /deep/ .ant-tree {
    margin-left: 0 !important;
    margin-right: 0 !important;
    height: 81%;
    overflow-y: auto;
    .anticon {
      background-color: #177efd;
      color: #fff;
    }
  }
  .iconOp {
    float: left;
    margin-top: 10px;
    margin-bottom: 5px;
    margin-left: 4px;
    .anticon {
      border: 1px solid #ddd;
      color: rgb(165, 165, 165);
      font-size: 18px;
      padding: 2px;
      margin-left: -4px;
      border-left: none;
      &:nth-of-type(1) {
        border-left: 1px solid #ddd;
      }
    }
  }
}
&::-webkit-scrollbar {
  width: 6px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 6px;
}
&::-webkit-scrollbar-thumb {
  border-radius: 6px;
  background: rgba(144, 147, 153, 0.5);
}
&::-webkit-scrollbar-track {
  border-radius: 5px;
  background: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/mTreeComplex.vue